const getCurrentVal = state => {
    return state.calculator.currentVal
}
export const calculatorSelectors = { getCurrentVal }
